import { useState } from "react";
import type { FormEvent } from "react";
import { UserPlus, UsersRound } from "lucide-react";
import type { SimulatorAppSurfaceProps } from "../AppSurface.js";

export function LocalUsersGroupsApp({ activeMachine, onRunCommand }: SimulatorAppSurfaceProps) {
  const [username, setUsername] = useState("local.student");
  const [groupName, setGroupName] = useState("Remote Desktop Users");

  async function createUser(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    await onRunCommand({
      appId: "lusrmgr",
      commandType: "LOCAL_USER_CREATE",
      capability: "local.user.write",
      label: `Create ${username}`,
      payload: {
        fullName: username,
        machineId: activeMachine,
        mustChangePassword: true,
        username
      }
    });
  }

  async function addMember() {
    await onRunCommand({
      appId: "lusrmgr",
      commandType: "LOCAL_GROUP_ADD_MEMBER",
      capability: "local.group.write",
      label: `Add ${username}`,
      payload: { groupName, machineId: activeMachine, username }
    });
  }

  return (
    <div className="fd-sim-app fd-sim-mmc">
      <aside className="fd-mmc-tree">
        <strong>Local Users and Groups</strong>
        <button className="is-active" type="button">Users</button>
        <button type="button">Groups</button>
      </aside>
      <section className="fd-mmc-list">
        <header>
          <h2>Users</h2>
          <span>{activeMachine}</span>
        </header>
        <form className="fd-command-form" onSubmit={(event) => void createUser(event)}>
          <label>
            User name
            <input value={username} onChange={(event) => setUsername(event.target.value)} />
          </label>
          <button type="submit">
            <UserPlus size={16} />
            New user
          </button>
        </form>
        <div className="fd-command-form">
          <label>
            Group
            <input value={groupName} onChange={(event) => setGroupName(event.target.value)} />
          </label>
          <button type="button" onClick={() => void addMember()}>
            <UsersRound size={16} />
            Add member
          </button>
        </div>
        <div className="fd-mmc-table">
          <div><strong>Administrator</strong><span>Built-in account</span></div>
          <div><strong>Guest</strong><span>Disabled</span></div>
          <div><strong>{username}</strong><span>Prepared ticket account</span></div>
        </div>
      </section>
      <aside className="fd-mmc-actions">
        <button type="button" onClick={() => void addMember()}>Add to group</button>
        <button
          type="button"
          onClick={() => {
            void onRunCommand({
              appId: "lusrmgr",
              commandType: "LOCAL_GROUP_CREATE",
              capability: "local.group.write",
              label: `Create ${groupName}`,
              payload: { groupName, machineId: activeMachine }
            });
          }}
        >
          New group
        </button>
      </aside>
    </div>
  );
}
